import React from 'react';
import { Link } from 'gatsby';
import { ArrowRightIcon } from 'brand/Icons';
import Checked from 'components/Brand/Icons/static/box-checked.png';
import Unchecked from 'components/Brand/Icons/static/box-unchecked.png';
import { WebsiteImage } from 'components/TitleDescription';
import { ChapterKicker, ChapterSections, ChapterTitle, StyledChapter } from '../styles';

const ChapterCard = ({ chapter, chapterNumber, chapterProgress, splashPageSlug }) => {
  const count = chapterProgress.reduce((x, y) => x + y);
  const label =
    count === 0 ? 'Get Started' : count === chapterProgress.length ? 'Read Again' : 'Continue';
  return (
    <StyledChapter
      bordered={false}
      backgroundColor={label === 'Read Again' ? '#F6F8FA' : '#FFFFFF'}
    >
      <ChapterKicker>
        CHAPTER {chapterNumber}
        <span>
          {label}
          <ArrowRightIcon />
        </span>
      </ChapterKicker>
      <ChapterTitle>{chapter.title}</ChapterTitle>
      {chapter.sections.map((section, index) => {
        return (
          <ChapterSections key={index} fontSize="16px">
            <WebsiteImage
              className="section-status"
              src={chapterProgress[index] ? Checked : Unchecked}
              alt="playbook-section-status"
            />
            <Link to={`/${splashPageSlug}/${section.slug}`}>{section.title}</Link>
          </ChapterSections>
        );
      })}
    </StyledChapter>
  );
};

export default ChapterCard;
